/* BV Goods - motion. Transform/opacity only, so nothing shifts layout. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Staggered reveal of product grids ---------------------------------- */
  function initStagger() {
    if (reduce || !('IntersectionObserver' in window)) return;

    document.querySelectorAll('.resource-list, .product-grid').forEach(function (grid) {
      if (grid.dataset.bvStagger) return;
      grid.dataset.bvStagger = '1';
      grid.classList.add('bv-stagger');

      Array.prototype.forEach.call(grid.children, function (item, i) {
        // Cap the cascade so the 40th tile isn't waiting two seconds
        item.style.setProperty('--bv-i', Math.min(i, 11));
      });

      new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' }).observe(grid);
    });
  }

  /* --- Cart bubble pop + BOGO confirmation -------------------------------- */
  function bubble() {
    return document.querySelector('.theme-drawer__badge, [class*="cart-bubble"], [class*="cart-count"]');
  }

  function ticker() {
    return document.querySelector('.marquee, [class*="marquee"]');
  }

  function pop() {
    var el = bubble();
    if (!el || reduce) return;
    el.classList.remove('bv-cart-pop');
    void el.offsetWidth; // restart the animation
    el.classList.add('bv-cart-pop');
    setTimeout(function () { el.classList.remove('bv-cart-pop'); }, 500);
  }

  /* The offer is buy-one-get-second. Confirm it the moment it becomes live. */
  var lastCount = null;
  function checkBogo(count) {
    if (reduce || count == null) return;
    if (lastCount !== null && lastCount < 2 && count >= 2) {
      var t = ticker();
      if (!t) return;
      t.classList.add('bv-ticker-flash');
      setTimeout(function () { t.classList.remove('bv-ticker-flash'); }, 1500);
    }
    lastCount = count;
  }

  function readCart() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) { checkBogo(c.item_count); })
      .catch(function () {});
  }

  /* Horizon dispatches cart updates; fall back to watching fetch calls. */
  ['cart:update', 'cart:updated', 'variant:add'].forEach(function (evt) {
    document.addEventListener(evt, function () { pop(); readCart(); });
  });

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var isAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    return origFetch.apply(this, arguments).then(function (res) {
      if (isAdd && res.ok) { pop(); setTimeout(readCart, 150); }
      return res;
    });
  };

  function init() {
    initStagger();
    readCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when the theme editor swaps a section
  document.addEventListener('shopify:section:load', initStagger);
})();

/* Size chart dialog */
(function () {
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-bv-size-open]');
    if (open) {
      var d = open.parentElement.querySelector('[data-bv-size-dialog]');
      if (d && d.showModal) d.showModal();
      return;
    }
    var close = e.target.closest('[data-bv-size-close]');
    if (close) {
      var dg = close.closest('dialog');
      if (dg) dg.close();
    }
  });
  // click outside the panel closes it
  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-bv-size-dialog]')) e.target.close();
  });
})();
